import React from "react";
import { useDispatch } from "react-redux";

import SubmitFilterButton from "../../components/SubmitFilterButton";

import {HIDE_MENU} from "../../Store/Actions/ActionTypes";

const SubmitFilterButtonContainer = () => {
    const dispatch = useDispatch();
    const buttonText = "Bekreft filter";
    const handleClick = () => {
        dispatch({type: HIDE_MENU});
    }

    return (
        <SubmitFilterButton buttonText={buttonText} clickHandler={handleClick}/>
    )
}

export default SubmitFilterButtonContainer;